module.exports = __webpack_public_path__ + "static/stromee-app-1-47bab43556824cb20a8957ee06b4f069.png";